import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';
import PendingPartners from '../components/Pending/PendingPartners';
import { PageHeader, PageShell } from 'components/layout/PageShell';

const AdminPartners = () => {
  const { t } = useTranslation();

  return (
    <PageShell>
      <Stack spacing={6}>
        <PageHeader
          title={t('Partners')}
          description={t('Review partner applications, check their documents, and keep approval decisions consistent.')}
        />
        <PendingPartners />
      </Stack>
    </PageShell>
  );
};

export default AdminPartners;
